const getters = {
	token: (state) => state.app.token, // 登入token
	commonConfig: (state) => (state.app.commonConfig ? JSON.parse(state.app.commonConfig) : state.app.commonConfig),
	// 系统下发翻译
	commonLanguage: (state) => (state.app.commonLanguage ? JSON.parse(state.app.commonLanguage) : state.app.commonLanguage),
	userInfo: (state) => (state.app.userInfo ? JSON.parse(state.app.userInfo) : state.app.userInfo), // userInfo
	language: (state) => state.app.language
};

export default getters;
